<template><section><h2>标题设置</h2>
<p><code v-pre>Tooltip</code> 的标题可以设置为 <code v-pre>string</code>，也可以设置为 <code v-pre>function</code>。两者区别：<code v-pre>string</code> 将固定标题为某字符串，<code v-pre>function</code> 则将 title 设置为函数返回值。</p>
<block-demo tip="" source="const data = [1, 2, 3, 4, 5].map((num) =&gt; {
  return { value: num }
})

const { Chart, Pie, Legend, Tooltip } = qcharts

const chart = new Chart({
  container: &#39;#app&#39;,
  size: [&#39;100%&#39;, &#39;100%&#39;]
})

chart.source(data, { value: &#39;value&#39; })

const pie = new Pie()

const tooltip = new Tooltip({ title: &#39;数字&#39;, formatter: (d) =&gt; d.value })

chart.append([pie, tooltip])
"><pre v-pre><code v-pre class="language-javascript"><span class="hljs-keyword">const</span> data = [<span class="hljs-number">1</span>, <span class="hljs-number">2</span>, <span class="hljs-number">3</span>, <span class="hljs-number">4</span>, <span class="hljs-number">5</span>].map(<span class="hljs-function">(<span class="hljs-params">num</span>) =&gt;</span> {
  <span class="hljs-keyword">return</span> { <span class="hljs-attr">value</span>: num }
})

<span class="hljs-keyword">const</span> { Chart, Pie, Legend, Tooltip } = qcharts

<span class="hljs-keyword">const</span> chart = <span class="hljs-keyword">new</span> Chart({
  <span class="hljs-attr">container</span>: <span class="hljs-string">'#app'</span>,
  <span class="hljs-attr">size</span>: [<span class="hljs-string">'100%'</span>, <span class="hljs-string">'100%'</span>]
})

chart.source(data, { <span class="hljs-attr">value</span>: <span class="hljs-string">'value'</span> })

<span class="hljs-keyword">const</span> pie = <span class="hljs-keyword">new</span> Pie()

<span class="hljs-keyword">const</span> tooltip = <span class="hljs-keyword">new</span> Tooltip({ <span class="hljs-attr">title</span>: <span class="hljs-string">'数字'</span>, <span class="hljs-attr">formatter</span>: <span class="hljs-function">(<span class="hljs-params">d</span>) =&gt;</span> d.value })

chart.append([pie, tooltip])
</code></pre>
</block-demo><block-demo tip="" source="const data = [1, 2, 3, 4, 5].map((num) =&gt; {
  return { value: num }
})

const { Chart, Pie, Legend, Tooltip } = qcharts

const chart = new Chart({
  container: &#39;#app&#39;,
  size: [&#39;100%&#39;, &#39;100%&#39;]
})

chart.source(data, { value: &#39;value&#39; })

const pie = new Pie()

const tooltip = new Tooltip({
  title: (d) =&gt; {
    return `数组 ${d[0].value}`
  },
  formatter: (d) =&gt; d.value
})

chart.append([pie, tooltip])
"><pre v-pre><code v-pre class="language-javascript"><span class="hljs-keyword">const</span> data = [<span class="hljs-number">1</span>, <span class="hljs-number">2</span>, <span class="hljs-number">3</span>, <span class="hljs-number">4</span>, <span class="hljs-number">5</span>].map(<span class="hljs-function">(<span class="hljs-params">num</span>) =&gt;</span> {
  <span class="hljs-keyword">return</span> { <span class="hljs-attr">value</span>: num }
})

<span class="hljs-keyword">const</span> { Chart, Pie, Legend, Tooltip } = qcharts

<span class="hljs-keyword">const</span> chart = <span class="hljs-keyword">new</span> Chart({
  <span class="hljs-attr">container</span>: <span class="hljs-string">'#app'</span>,
  <span class="hljs-attr">size</span>: [<span class="hljs-string">'100%'</span>, <span class="hljs-string">'100%'</span>]
})

chart.source(data, { <span class="hljs-attr">value</span>: <span class="hljs-string">'value'</span> })

<span class="hljs-keyword">const</span> pie = <span class="hljs-keyword">new</span> Pie()

<span class="hljs-keyword">const</span> tooltip = <span class="hljs-keyword">new</span> Tooltip({
  <span class="hljs-attr">title</span>: <span class="hljs-function">(<span class="hljs-params">d</span>) =&gt;</span> {
    <span class="hljs-keyword">return</span> <span class="hljs-string">`数组 <span class="hljs-subst">${d[<span class="hljs-number">0</span>].value}</span>`</span>
  },
  <span class="hljs-attr">formatter</span>: <span class="hljs-function">(<span class="hljs-params">d</span>) =&gt;</span> d.value
})

chart.append([pie, tooltip])
</code></pre>
</block-demo></section></template><script>export default {components:{}}</script>